module.exports = __webpack_public_path__ + "img/box.4035c56e.svg";